export default "__VITE_ASSET__CxFYmdKX__"